// extracted by mini-css-extract-plugin
module.exports = {"outer":"GaKY9","heading":"_2bAs1","wrapper":"_24BXu"};